// import React from 'react';

// const Book = () => {
//   return (
//     <div className="pt-20">
//       {/* Hero Section */}
//       <section className="py-12 bg-gray-50">
//         <div className="container mx-auto px-6">
//           <div className="max-w-3xl mx-auto text-center">
//             <h1 className="text-4xl font-bold text-gray-900 mb-4">Book a Consultation</h1>
//             <div className="w-20 h-1 bg-yana-orange mx-auto mb-6"></div>
//             <p className="text-lg text-gray-600">
//               Schedule your appointment with our experts for any radiology service you need.
//             </p>
//           </div>
//         </div>
//       </section>

     
// <section className="px-4 sm:px-6 lg:px-8 py-6 sm:py-8 md:py-10 lg:py-12 xl:py-14 max-w-7xl mx-auto">
//   <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
    
//     {/* Right: Text card comes FIRST on mobile */}
//     <div className="order-1 md:order-2 bg-gray-50 p-4 rounded-2xl self-start">
//       {/* Booking Heading */}
//       <h2 className="text-xl font-bold text-gray-900 mb-2">Online Appointment Booking</h2>
//       <p className="text-gray-600 mb-4 text-sm">
//         Please select a convenient time slot from our online calendar below.
//         If you don't see a time that works for you, please contact us directly at
//         <a href="tel:+919900500950" className="text-yana-orange font-medium ml-1 hover:underline">
//           +91 9900500950
//         </a>.
//       </p>

//       {/* Before Your Appointment */}
//       <h3 className="text-lg font-semibold text-gray-900 mb-3">Before Your Appointment</h3>
//       <ul className="space-y-2 text-sm text-gray-700 leading-snug">
//         {[
//           "Please bring your doctor's referral form if applicable.",
//           "Arrive 15 minutes before your scheduled appointment time to complete any necessary paperwork.",
//           "Bring your identification and any relevant previous scan results or medical records.",
//           "Specific preparation instructions will be provided after booking, if applicable for your procedure."
//         ].map((item, idx) => (
//           <li key={idx} className="flex items-start">
//             <svg
//               className="w-4 h-4 text-yana-orange mt-0.5 flex-shrink-0 mr-2"
//               fill="none"
//               viewBox="0 0 24 24"
//               stroke="currentColor"
//             >
//               <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
//             </svg>
//             <span>{item}</span>
//           </li>
//         ))}
//       </ul>
//     </div>

//     {/* Left: Iframe comes SECOND on mobile */}
//     <div className="order-2 md:order-1 border border-gray-200 rounded-2xl overflow-hidden">
//       <iframe
//         className="w-full"
//         style={{ height: '750px' }}
//         src="https://yanalabs.mediva.in"
//         frameBorder="0"
//         allowFullScreen
//       />
//     </div>

//   </div>
// </section>





//       {/* Contact Information */}
//       <section className="py-16 bg-gray-50">
//         <div className="container mx-auto px-6">
//           <div className="max-w-5xl mx-auto">
//             <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
//               <div className="bg-white p-6 rounded-lg shadow-md text-center hover:shadow-lg transition-shadow">
//                 <div className="w-16 h-16 bg-yana-orange bg-opacity-10 rounded-full flex items-center justify-center mx-auto mb-4">
//                   <i className="fas fa-phone-alt text-yana-orange text-xl"></i>
//                 </div>
//                 <h3 className="text-xl font-semibold text-gray-800 mb-2">Phone</h3>
//                 <p className="text-gray-600 mb-3">
//                   Call us directly to schedule an appointment
//                 </p>
//                 <a href="tel:+91 9900500950" className="inline-block text-yana-orange font-medium hover:text-yana-orange-dark">
//                  +91 9900500950
//                 </a>
//               </div>
              
//               <div className="bg-white p-6 rounded-lg shadow-md text-center hover:shadow-lg transition-shadow">
//                 <div className="w-16 h-16 bg-yana-orange bg-opacity-10 rounded-full flex items-center justify-center mx-auto mb-4">
//                   <i className="fas fa-envelope text-yana-orange text-xl"></i>
//                 </div>
//                 <h3 className="text-xl font-semibold text-gray-800 mb-2">Email</h3>
//                 <p className="text-gray-600 mb-3">
//                   Send us an email with your preferred date and time
//                 </p>
//                 <a href="mailto:booking@yanahealth.com" className="inline-block text-yana-orange font-medium hover:text-yana-orange-dark">
//                   yanahealth0501@gmail.com
//                 </a>
//               </div>
              
//               <div className="bg-white p-6 rounded-lg shadow-md text-center hover:shadow-lg transition-shadow">
//                 <div className="w-16 h-16 bg-yana-orange bg-opacity-10 rounded-full flex items-center justify-center mx-auto mb-4">
//                   <i className="fas fa-clock text-yana-orange text-xl"></i>
//                 </div>
//                 <h3 className="text-xl font-semibold text-gray-800 mb-2">Working Hours</h3>
//                 <p className="text-gray-600 mb-1">Monday - Saturday: 8am - 10pm</p>
//                 {/* <p className="text-gray-600 mb-1">Saturday: 8am - 6pm</p> */}
//                 <p className="text-gray-600">Sunday: 10am - 10pm</p>
//               </div>
//             </div>
//           </div>
//         </div>
//       </section>
//     </div>
//   );
// };

// export default Book;





import React, { useState } from 'react';
import CategoryCards from '../components/booking/CategoryCards';
import ItemList from '../components/booking/ItemList';
import IframeView from '../components/booking/IframeView';
import useCategoryItems from '../hooks/useCategoryItems';

const Book = () => {
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [selectedItem, setSelectedItem] = useState(null);
  const [searchQuery, setSearchQuery] = useState('');
  const [currentPage, setCurrentPage] = useState(1);

  const { items, isLoading, error } = useCategoryItems(selectedCategory);

  const itemsPerPage = 12;

  const filteredItems = Array.isArray(items)
    ? items.filter(item =>
        item.title.toLowerCase().includes(searchQuery.toLowerCase())
      )
    : [];

  const paginatedItems = filteredItems.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  const totalPages = Math.ceil(filteredItems.length / itemsPerPage);

  const handleBack = () => {
    if (selectedItem) {
      setSelectedItem(null); // from iframe to item list
    } else {
      setSelectedCategory(null); // from item list to category cards
      setSearchQuery('');
      setCurrentPage(1);
    }
  };

  return (
    <div className="pt-20">
      {/* Hero Section */}
      <section className="py-12 bg-gray-50">
        <div className="container mx-auto px-6">
          <div className="max-w-3xl mx-auto text-center">
            <h1 className="text-4xl font-bold text-gray-900 mb-4">Book a Consultation</h1>
            <div className="w-20 h-1 bg-yana-orange mx-auto mb-6"></div>
            <p className="text-lg text-gray-600">
              Schedule your appointment with our experts for any radiology service you need.
            </p>
          </div>
        </div>
      </section>

      {/* Main Content Area */}
      <section className="px-4 sm:px-6 lg:px-8 py-6 max-w-7xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {/* Booking Info Section */}
          <div className="order-1 md:order-2 bg-gray-50 p-4 rounded-2xl self-start">
            <h2 className="text-xl font-bold text-gray-900 mb-2">Online Appointment Booking</h2>
            <p className="text-gray-600 mb-4 text-sm">
              Please select a convenient time slot from our online calendar below.
              If you don't see a time that works for you, please contact us directly at
              <a href="tel:+919900500950" className="text-yana-orange font-medium ml-1 hover:underline">
                +91 9900500950
              </a>.
            </p>
            <h3 className="text-lg font-semibold text-gray-900 mb-3">Before Your Appointment</h3>
            <ul className="space-y-2 text-sm text-gray-700 leading-snug">
              {[
                "Please bring your doctor's referral form if applicable.",
                "Arrive 15 minutes before your scheduled appointment time to complete any necessary paperwork.",
                "Bring your identification and any relevant previous scan results or medical records.",
                "Specific preparation instructions will be provided after booking, if applicable for your procedure."
              ].map((item, idx) => (
                <li key={idx} className="flex items-start">
                  <svg
                    className="w-4 h-4 text-yana-orange mt-0.5 flex-shrink-0 mr-2"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                  </svg>
                  <span>{item}</span>
                </li>
              ))}
            </ul>
          </div>

          {/* Iframe or Category/Item Selection */}
          <div className="order-2 md:order-1 border border-gray-200 rounded-2xl overflow-hidden w-full p-4">
            {selectedItem ? (
              <>
                <button
                  onClick={handleBack}
                  className="mb-4 px-4 py-2 bg-gray-200 rounded hover:bg-gray-300 text-sm"
                >
                  ← Back to Items
                </button>
                <IframeView item={selectedItem} />
              </>
            ) : selectedCategory ? (
              <>
                <button
                  onClick={handleBack}
                  className="mb-4 px-4 py-2 bg-gray-200 rounded hover:bg-gray-300 text-sm"
                >
                  ← Back to Categories
                </button>
                <ItemList
                  items={paginatedItems}
                  searchQuery={searchQuery}
                  onSearch={setSearchQuery}
                  currentPage={currentPage}
                  onPageChange={setCurrentPage}
                  totalPages={totalPages}
                  onItemSelect={setSelectedItem}
                  isLoading={isLoading}
                  error={error}
                />
              </>
            ) : (
              <CategoryCards onSelect={(cat) => setSelectedCategory(cat.json)} />
            )}
          </div>
        </div>
      </section>

      {/* Contact Info Section */}
      <section className="py-16 bg-gray-50">
        <div className="container mx-auto px-6">
          <div className="max-w-5xl mx-auto">
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
              {[
                {
                  icon: 'phone-alt',
                  title: 'Phone',
                  content: 'Call us directly to schedule an appointment',
                  link: 'tel:+91 9900500950',
                  text: '+91 9900500950'
                },
                {
                  icon: 'envelope',
                  title: 'Email',
                  content: 'Send us an email with your preferred date and time',
                  link: 'mailto:booking@yanahealth.com',
                  text: 'yanahealth0501@gmail.com'
                },
                {
                  icon: 'clock',
                  title: 'Working Hours',
                  content: 'Monday - Saturday: 8am - 10pm',
                  extra: 'Sunday: 10am - 10pm'
                }
              ].map((info, i) => (
                <div
                  key={i}
                  className="bg-white p-6 rounded-lg shadow-md text-center hover:shadow-lg transition-shadow"
                >
                  <div className="w-16 h-16 bg-yana-orange bg-opacity-10 rounded-full flex items-center justify-center mx-auto mb-4">
                    <i className={`fas fa-${info.icon} text-yana-orange text-xl`} />
                  </div>
                  <h3 className="text-xl font-semibold text-gray-800 mb-2">{info.title}</h3>
                  <p className="text-gray-600 mb-3">{info.content}</p>
                  {info.link ? (
                    <a href={info.link} className="inline-block text-yana-orange font-medium hover:text-yana-orange-dark">
                      {info.text}
                    </a>
                  ) : (
                    <p className="text-gray-600">{info.extra}</p>
                  )}
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Book;
